export enum AuthenticationEvents {
    ForceSignOut = 'Authentication.ForceSignOut',
}